export const baseURL = process.env.VUE_APP_API_URL || 'https://rest.gestaoclick.com/';